import React from "react";
import Header from "@/components/header";
import Footer from "@/components/footer";

import Head from "next/head";
import Link from "next/link";
import dynamic from "next/dynamic";

// Import distributor components dynamically with SSR disabled to avoid framer-motion issues
const DistributorFeatures = dynamic(
  () => import("@/components/distributor-features"),
  {
    ssr: false,
    loading: () => (
      <div className="h-96 bg-gray-100 animate-pulse rounded"></div>
    ),
  },
);

const DistributorFaq = dynamic(() => import("@/components/distributor-faq"), {
  ssr: false,
  loading: () => <div className="h-64 bg-gray-100 animate-pulse rounded"></div>,
});

import { ChatCircleDotsIcon } from "@phosphor-icons/react";

import { motion } from "framer-motion";
import { titleAnimate, titleInitial } from "@/components/animations";
import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "@phosphor-icons/react";
const DistributorDemo = dynamic(() => import("@/components/distributor-demo"), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded"></div>,
});
import MapBackground from "@/components/map-background";

// Force SSR to avoid framer-motion static generation issues
export async function getServerSideProps() {
  return { props: {} };
}

export default function Brands() {
  return (
    <div>
      <Head>
        <title>Become a Partbot Fulfilment Distributor</title>
      </Head>
      <Header />

      <main>
        {/* Hero section */}
        <MapBackground />
        <div className="relative flex min-h-[90dvh] flex-col items-end justify-end pt-24">
          <div className="container mx-auto">
            <div className="relative sm:overflow-hidden">
              <div className="mt:py-16 wrap-balance relative px-6 py-6 xl:px-6">
                <motion.h1
                  initial={titleInitial}
                  whileInView={titleAnimate()}
                  viewport={{ once: true }}
                  className="text-balance bg-linear-to-r pb-5 text-4xl font-bold leading-none drop-shadow-lg text-stone-50 lg:text-6xl xl:text-7xl lg:max-w-6xl"
                >
                  Join the Partbot Automotive Fulfilment Network
                </motion.h1>
                <motion.p
                  initial={titleInitial}
                  whileInView={titleAnimate(0.5)}
                  viewport={{ once: true }}
                  className="mt-3 max-w-prose text-balance text-lg text-emerald-300/75 md:mt-6"
                >
                  Connect with your stockists and automate your order processing
                  using Partbot&apos;s powerful fulfilment and logistics
                  platform.
                </motion.p>
                <div className="mt-9">
                  <motion.div
                    initial={titleInitial}
                    whileInView={titleAnimate(0.5, 2)}
                    viewport={{ once: true }}
                  >
                    <Button asChild className="bg-emerald-500">
                      <Link href="/contact">
                        <span className="mr-2">Get Started for Free</span>
                        <ArrowRightIcon />
                      </Link>
                    </Button>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DistributorDemo />

        <DistributorFeatures />

        <DistributorFaq />
      </main>
      <Footer />
    </div>
  );
}
